var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "b-input-group",
                {
                  staticClass: "main-search-mini mt-3 d-flex d-md-none",
                  scopedSlots: _vm._u([
                    {
                      key: "prepend",
                      fn: function () {
                        return [
                          _c(
                            "b-button",
                            {
                              staticClass: "menu-min",
                              on: { click: _vm.showMiniMenu },
                            },
                            [
                              _c("router-link", { attrs: { to: "#" } }, [
                                _c("img", {
                                  attrs: {
                                    src: require("../assets/company_min.svg"),
                                  },
                                }),
                              ]),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "append",
                      fn: function () {
                        return [
                          _c(
                            "b-button",
                            {
                              staticClass: "btn-search",
                              attrs: { variant: "outline-primary" },
                              on: { click: _vm.openSearchMini },
                            },
                            [
                              _c("i", { staticClass: "material-icons md-16" }, [
                                _vm._v("search"),
                              ]),
                            ]
                          ),
                          _c(
                            "b-button",
                            {
                              staticClass: "btn-search",
                              attrs: { variant: "outline-primary" },
                              on: { click: _vm.onClickDropdown },
                            },
                            [
                              _c("i", { staticClass: "material-icons md-16" }, [
                                _vm._v("account_circle"),
                              ]),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      type: "search",
                      pattern: _vm.SEARCH_PATTERN,
                      required: "",
                      placeholder: "Search resource...",
                      autocomplete: "off",
                    },
                    on: { click: _vm.openSearchMini },
                    model: {
                      value: _vm.q,
                      callback: function ($$v) {
                        _vm.q = $$v
                      },
                      expression: "q",
                    },
                  }),
                ],
                1
              ),
              _vm.$parent.isUserMenu
                ? _c(
                    "div",
                    { staticClass: "template-user d-block d-md-none" },
                    [
                      _c("div", {
                        staticClass: "background-search",
                        on: { click: _vm.closeBackground },
                      }),
                      _c(
                        "div",
                        {
                          staticClass: "dropdown-content text-left",
                          attrs: { id: "myDropdown-mini" },
                        },
                        [
                          _c("a", [
                            _c("i", { staticClass: "material-icons md-16" }, [
                              _vm._v("account_circle"),
                            ]),
                            _vm._v(_vm._s(_vm.userLogin.displayName)),
                          ]),
                          _c("a", [
                            _c("i", { staticClass: "material-icons md-16" }, [
                              _vm._v("domain"),
                            ]),
                            _vm._v(_vm._s(_vm.domainUser)),
                          ]),
                          _c("a", { on: { click: _vm.signout } }, [
                            _c("i", { staticClass: "material-icons md-16" }, [
                              _vm._v("exit_to_app"),
                            ]),
                            _vm._v("Logout"),
                          ]),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.$parent.isSearchMini
                ? _c(
                    "div",
                    { staticClass: "template-search d-block d-md-none" },
                    [
                      _c("div", {
                        staticClass: "background-search",
                        on: { click: _vm.closeBackground },
                      }),
                      _c("div", { staticClass: "dropdown-search pt-3 pb-3" }, [
                        _c(
                          "div",
                          { staticClass: "col-12 pb-3" },
                          [
                            _c(
                              "b-dropdown",
                              {
                                staticClass: "m-0 w-100 btn-domains",
                                attrs: {
                                  text: _vm.pick_domain,
                                  variant: "primary",
                                },
                              },
                              _vm._l(_vm.processd_list_domains, function (opt) {
                                return _c(
                                  "b-dropdown-item",
                                  {
                                    key: opt,
                                    attrs: { value: opt },
                                    on: {
                                      click: function ($event) {
                                        _vm.pick_domain = opt
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(opt))]
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "col-12 pb-3" }, [
                          _c(
                            "div",
                            _vm._l(_vm.buttons, function (btn, idx) {
                              return _c(
                                "b-button",
                                {
                                  key: idx,
                                  staticClass: "mr-2",
                                  attrs: {
                                    pill: "",
                                    size: "sm",
                                    variant: btn.color,
                                    pressed: btn.state,
                                    disabled: btn.disabled,
                                  },
                                  on: {
                                    "update:pressed": function ($event) {
                                      return _vm.$set(btn, "state", $event)
                                    },
                                    click: function ($event) {
                                      return _vm.onClickButton(btn)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(btn.caption))]
                              )
                            }),
                            1
                          ),
                        ]),
                        _c(
                          "div",
                          { staticClass: "col-12 text-right" },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "mr-2",
                                attrs: { variant: "outline", size: "sm" },
                                on: {
                                  click: function ($event) {
                                    return _vm.openSearchMini()
                                  },
                                },
                              },
                              [_c("span", [_vm._v("Close")])]
                            ),
                            _c(
                              "b-button",
                              {
                                attrs: {
                                  variant: "outline-primary",
                                  size: "sm",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.applySearchMini()
                                  },
                                },
                              },
                              [_c("span", [_vm._v("Apply")])]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
              _c(
                "b-input-group",
                {
                  staticClass: "main-search d-none d-md-flex",
                  scopedSlots: _vm._u([
                    {
                      key: "append",
                      fn: function () {
                        return [
                          _c(
                            "b-dropdown",
                            {
                              staticClass: "m-0",
                              attrs: {
                                text: _vm.pick_domain,
                                variant: "primary",
                              },
                            },
                            _vm._l(_vm.processd_list_domains, function (opt) {
                              return _c(
                                "b-dropdown-item",
                                {
                                  key: opt,
                                  attrs: { value: opt },
                                  on: {
                                    click: function ($event) {
                                      _vm.pick_domain = opt
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(opt))]
                              )
                            }),
                            1
                          ),
                          _c(
                            "b-button",
                            {
                              staticClass: "btn-search",
                              attrs: { variant: "outline-primary" },
                              on: { click: _vm.sendToSearch },
                            },
                            [
                              _c("i", { staticClass: "material-icons md-16" }, [
                                _vm._v("search"),
                              ]),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      type: "search",
                      pattern: _vm.SEARCH_PATTERN,
                      required: "",
                      placeholder: "Search resource...",
                      autocomplete: "off",
                    },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.sendToSearch($event)
                      },
                    },
                    model: {
                      value: _vm.q,
                      callback: function ($$v) {
                        _vm.q = $$v
                      },
                      expression: "q",
                    },
                  }),
                  _c(
                    "i",
                    {
                      directives: [
                        {
                          name: "b-popover",
                          rawName: "v-b-popover.hover.top",
                          value: "More options to search",
                          expression: "'More options to search'",
                          modifiers: { hover: true, top: true },
                        },
                      ],
                      staticClass: "material-icons md-16 btn-more-filters",
                      on: { click: _vm.openSearchFilter },
                    },
                    [_vm._v("tune")]
                  ),
                  _c("div", { staticClass: "container-more-filter" }, [
                    _c(
                      "span",
                      [
                        _c("more-filter-search", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.$parent.show_more_filter,
                              expression: "$parent.show_more_filter",
                            },
                          ],
                          on: {
                            onSearchFilter: _vm.onSearchFilter,
                            closeSearchFilter: _vm.closeSearchFilter,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c("b-col", { attrs: { sm: "12" } }, [
            _c(
              "div",
              { staticClass: "buttons-search" },
              _vm._l(_vm.buttons, function (btn, idx) {
                return _c(
                  "b-button",
                  {
                    key: idx,
                    staticClass: "mr-2",
                    attrs: {
                      pill: "",
                      size: "sm",
                      variant: btn.color,
                      pressed: btn.state,
                      disabled: btn.disabled,
                    },
                    on: {
                      "update:pressed": function ($event) {
                        return _vm.$set(btn, "state", $event)
                      },
                      click: function ($event) {
                        return _vm.onClickButton(btn)
                      },
                    },
                  },
                  [_vm._v(_vm._s(btn.caption))]
                )
              }),
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }